'use client';
import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScFAQSection = styled.div`
  & > h2 {
    font-size: 22px;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: 0.02em;
    text-align: center;
    color: ${({ theme }) => theme.whiteColor};
    margin-bottom: 24px;

    @media (${device.mobile}) {
      font-size: 20px;
    }
  }
`;
